import { render, staticRenderFns } from "./aiSummary.vue?vue&type=template&id=55911f36&scoped=true&lang=pug"
import script from "./aiSummary.vue?vue&type=script&lang=js"
export * from "./aiSummary.vue?vue&type=script&lang=js"
import style0 from "./aiSummary.vue?vue&type=style&index=0&id=55911f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55911f36",
  null
  
)

export default component.exports